<!--
@Author: MIYONGLE
@Desc: 产品服务-慧用工h5+
@Date: 2021-07-28 13时
-->
<template>
  <div class="page-main">
    <!-- 顶部 -->
    <mMenusNav><span>{{ titleName }}</span></mMenusNav>

    <!-- 产品服务背景 -->
    <div class="ps-banner">
      <div class="prodserv-title">
        <p>免费高效</p>
        <p>解决企业用工荒难题</p>
      </div>
      <div class="prodserv-txt">慧用工，免费高效解决企业用工荒难题，帮助个人多渠道就业</div>
      <div class="prodserv-btn" @click="opearMth"><p>立即咨询</p></div>
    </div>

    <!-- 解决问题从场景开始 -->
    <div class="solve-problem">
      <div class="solve-problem-title">解决问题，从场景开始</div>
      <div class="solve-problem-switch">
        <span class="tab" :class="activeType == 'one' && 'active'" @click="clickTab('one')">企业</span>
        <span class="tab" :class="activeType == 'two' && 'active'" @click="clickTab('two')">新个体</span>
        <p :class="activeType == 'one' && 'slider'"></p>
        <p :class="activeType == 'two' && 'slider1'"></p>
        
        <!-- 场景主题 -->
        <div class="tab-content">
          <div class="item" v-for="(item, index) in productList" :key="index">
            <img :src="item.imgUrl" alt="">
            <span class="title">{{item.title}}</span>
            <span class="text" v-html="item.text"></span>
          </div>
        </div>
      </div>    
    </div>

    <!-- 我们能为你做什么 -->
    <div class="cando">
      <div class="cando-title">我们能为你做什么</div>
      <div class="cando-text">自由职业者完成企业发布的任务后，平台会根据企业设定的审核标准在线智能审核</div>
      <img src="../../../static/mobile/mprodServ_h5/img_product_phone.png" alt="">
    </div>
    <!-- form弹窗 -->
    <mFrom :source='source'></mFrom>
  </div>
</template>

<script type="text/javascript">
import mMenusNav from "../../components/mMenusNav";
import mFrom from "../../components/mFrom";
export default {
  name: "app",
  data() {
    return {
      source: '',
      productList:[
        {imgUrl:'../../../static/mobile/mprodServ_h5/product_icon_zhaorennan.png', title:'招人难', text:'就业人员不稳定 </br> 合适的人员难找'},
        {imgUrl:'../../../static/mobile/mprodServ_h5/product_icon_guanliluan.png', title:'管理乱', text:'招工渠道过多 </br> 无法统一管理'},
        {imgUrl:'../../../static/mobile/mprodServ_h5/product_icon_xiaolvdi.png', title:'效率低', text:'招工时效、质量</br> 服务跟不上'}
      ],
      titleName: "灵活用工系统",
      activeType: 'one',
    }
  },
  components: {
    mMenusNav: mMenusNav,
    mFrom: mFrom,
  },
  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=mcpfw_hyg' : '&pageFrom=mcpfw_hyg'; 
  },
  methods: {
    // 打开弹框
    opearMth(){
      eventBus.$emit("operaDiaLog", true);
    },

    clickTab(type){
      this.activeType = type;
      if(type == 'one'){
        this.productList = [
          {imgUrl:'../../../static/mobile/mprodServ_h5/product_icon_zhaorennan.png', title:'招人难', text:'就业人员不稳定</br> 合适的人员难找'},
          {imgUrl:'../../../static/mobile/mprodServ_h5/product_icon_guanliluan.png', title:'管理乱', text:'招工渠道过多 </br>无法统一管理'},
          {imgUrl:'../../../static/mobile/mprodServ_h5/product_icon_xiaolvdi.png', title:'效率低', text:'招工时效、质量</br>服务跟不上'}
        ]

      } else if(type == 'two'){
        this.productList = [
          {imgUrl:'../../../static/mobile/mprodServ_h5/img_icon_gongzuonanzhao.png', title:'工作难找', text:'适合自己的岗位 </br> 难找'},
          {imgUrl:'../../../static/mobile/mprodServ_h5/img_icon_zhongjieguoduo.png', title:'中介过多', text:'中介层层转介绍 </br> 过程复杂'},
          {imgUrl:'../../../static/mobile/mprodServ_h5/img_icon_butouming.png', title:'不透明', text:'招工信息不透明</br>费用不透明'}
        ]
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.ps-banner{
  width: 100%;
  height: 1080px;
  overflow: hidden;
  background-image: url(../../../static/mobile/mprodServ_h5/banner_product_2.png);
  background-repeat:no-repeat;
  background-size: 100%;
  background-color: #111010;
  .prodserv-title{
    margin: 0 auto;
    margin-top: 354px;
    // width: 622px;
    height: 152px;
    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 76px;
  }
  .prodserv-txt{
    margin: 0 auto;
    margin-top: 29px;
    padding: 0px 173.5px;
    // width: 403px;
    height: 80px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
  }
  .prodserv-btn{
    margin: 0 auto;
    margin-top: 66px;
    width: 288px;
    height: 80px;
    background: #1985FF;
    border-radius: 40px;
    p{
      margin:0 auto;
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 80px;
    }
  }
}

.solve-problem{
  margin:0 auto;
  width: 100%;
  // width: 750px;
  height: 690px;
  overflow: hidden;
  background: #FBFDFF;
  // background-color: red;
  .solve-problem-title{
    margin: 0 auto;
    margin-top: 70px;
    // width: 400px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100F0F;
    line-height: 56px;
  }
  .solve-problem-switch{
    margin: 0 auto;
    width: 690px;
    height: 106px;
    background-color: #fff;
    border-bottom: 1px solid #CFCFCF;
    .tab{
      margin-top: 53px;
      display: inline-block;
      margin-right: 50px;
      margin-left: 50px;
      font-size: 32px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 500;
      color: #171E2E;
    }
    .active{
      color:rgb(25, 133, 255);
    }
    .slider{
      margin-top: 7px;
      margin-left: 150px;
      width: 180px;
      height: 4px;
      background: #1985FF;
      box-shadow: 0px 20px 60px 0px rgba(0, 0, 0, 0.1);
      border-radius: 25px;
    }
    .slider1{
      margin-top: 7px;
      margin-left: 330px;
      width: 180px;
      height: 4px;
      background: #1985FF;
      box-shadow: 0px 20px 60px 0px rgba(0, 0, 0, 0.1);
      border-radius: 25px;
    }
    .tab-content{
      background-color: #FBFDFF;
      display: flex;
      justify-content: space-around;
      height: 454px;
      .item{
          width:210px;
          height: 285px;
          margin-top: 72px;
          text-align: center;
          font-size: 16px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          padding:0 53px;
          // background-color: yellow;
          img{
            width:138px;
          }
          .title{
            // margin:0 auto;
            text-align: center;
            margin-top: 32px;
            width: 180px;
            height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 40px;
            color: #403F3F;
          }
          .text{
            width: 180px;
            height: 60px;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #403F3F;
            text-align: center;
            line-height: 30px;
            word-break : normal;
          }
      }
    }
  }
}

.cando{
  height: 959px;
  overflow: hidden;
  .cando-title{
    margin:0 auto;
    margin-bottom: 31px;
    // width: 320px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100F0F;
    line-height: 56px;
  }
  .cando-text{
    margin:0 auto;
    // width: 590px;
    padding: 0px 80px;
    height: 72px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #403F3F;
    line-height: 36px;
  }
  img{
    // width: 502px;
    height: 672px;
    margin: 0 auto;
    margin-top: 28px;

  }
}


</style>


// WEBPACK FOOTER //
// src/views/mobile/mProdServ_h5.vue